import React, { useEffect, useRef, useState } from 'react'
import { Formik, Form } from 'formik'
import { Box, Chip, Typography } from '@mui/material'
import Bugsnag from '@bugsnag/js'
import { useMutation, useQuery } from 'react-query'
import { handleValidationErrors } from 'services/helper/handleValidationErrors'
import ACMatchingCsvUpload from '../components/ACMatchingCsvUpload'

// API
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import AdxInput from 'components/custom/AdxInput'
import { getEvaluation } from 'services/api/modules/performance/appraisal/evaluation'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'
import { uploadMatching } from 'services/api/modules/performance/appraisal/appraisal'
import AdxButton from 'components/custom/AdxButton'

const UploadMatching = ({
  customMatchingId,
  handleCloseMatchingCSV,
  matchingCSVUpload,
  setShowMatchingTable,
  setGetMatchingData,
  setCompleteUploadMatching,
  completeUploadMatching,
  staffData,
  setUpload,
  upload,
  mutateConfirmUploadMatching,
  setMatchingLoading,
}) => {
  const formikRef = useRef()
  const [evaluationTitle, setEvaluationTitle] = useState('')
  const [description, setDescription] = useState('')
  const [getQuery, setGetQuery] = useState(false)
  const [departmentSelected, setDepartmentSelected] = useState([])

  const { data: evaluationData } = useQuery(['evalData', customMatchingId], async () => {
    const { data } = await getEvaluation(customMatchingId)
    return data
  })

  const { data: departmentData } = useQuery(
    ['allDepartmentData', evaluationData?.['Evaluation']?.['participant_departments']],
    async () => {
      const newData = { name: 'All Departments', id: 'all' }
      let { data } = await getAllDepartment()
      if (data) {
        data.push(newData)
        const evalDepartments = evaluationData?.['Evaluation']?.['participant_departments']
        let arr = []

        data?.map((item) =>
          evalDepartments?.map((evalDept) => (item.id === evalDept ? arr.push(item) : null))
        )
        data = arr
        return data
      }
    },
    { enabled: getQuery }
  )

  const { mutate: mutateCheckParticipants, isLoading: matchCSV } = useMutation(uploadMatching, {
    onSuccess: (response) => {
      setGetMatchingData(response.data)
      setShowMatchingTable(true)
      setUpload(true)
    },
    onError: (error) => {
      if (error.status === 422) {
        if (error.data?.errors) {
          handleValidationErrors(error, formikRef)
        } else {
          let errors = {
            import_participant_file: [error.data.message],
          }
          let newError = {
            data: {
              errors,
            },
          }
          handleValidationErrors(newError, formikRef)
        }
      } else {
        Bugsnag.notify(error.data)
        let errors = {
          import_participant_file: [error.data.message],
        }
        let newError = {
          data: {
            errors,
          },
        }
        handleValidationErrors(newError, formikRef)
      }
    },
  })
  useEffect(() => {
    setMatchingLoading(matchCSV)
  }, [matchCSV])

  const handleUploadMatching = async (values) => {
    let newData = values.import_participant_file[0]
    let formData = new FormData()
    formData.append('import_participant_file', newData)

    mutateCheckParticipants({ evalId: customMatchingId, data: formData })
  }

  useEffect(() => {
    setDepartmentSelected(departmentData)
  }, [departmentData])

  useEffect(() => {
    const data = evaluationData?.['Evaluation']

    data ? setGetQuery(true) : setGetQuery(false)

    setEvaluationTitle(data?.['title'])

    setDescription(data?.['description'])
  }, [evaluationData])

  useEffect(() => {
    if (completeUploadMatching === true) {
      setUpload(true)
    } else if (completeUploadMatching === false) {
      setUpload(false)
    }
  }, [completeUploadMatching]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirm = (state) => {
    setCompleteUploadMatching(state)
    state ? setUpload(true) : setUpload(false)
  }

  const handleUpload = () => {
    mutateConfirmUploadMatching({ evalId: customMatchingId, data: staffData })
  }

  return (
    <>
      <AdxFormModal
        open={matchingCSVUpload}
        onClose={handleCloseMatchingCSV}
        handleClose={handleCloseMatchingCSV}
        title={'Upload custom matching CSV'}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ paddingBottom: '10px' }}>
            <Typography variant="body1">Evaluation Name</Typography>
            <AdxInput placeholder={evaluationTitle} disabled />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Description</Typography>
            <AdxInput multiline placeholder={description} disabled />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Department Selection</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                overflowX: 'auto',
                gap: '5px',
              }}
            >
              {departmentSelected?.map((value) => (
                <Chip key={value.id} label={value.name} />
              ))}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Matching file</Typography>
            <Box
              sx={{
                border: 1,
                borderColor: 'gray-line.main',
                borderRadius: '4.5px',
                p: 2,
              }}
            >
              <Formik
                enableReinitialize
                initialValues={{
                  import_participant_file: null,
                }}
                onSubmit={handleUploadMatching}
                innerRef={formikRef}
              >
                {(formikProps) => (
                  <>
                    <Form>
                      <ACMatchingCsvUpload
                        formikProps={formikProps}
                        handleConfirm={handleConfirm}
                        setCompleteUploadMatching={setCompleteUploadMatching}
                        completeUploadMatching={completeUploadMatching}
                        setUpload={setUpload}
                      />
                    </Form>
                  </>
                )}
              </Formik>
            </Box>
            {upload && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <AdxButton
                  variant={'outlined'}
                  sx={{ width: '100px' }}
                  onClick={handleCloseMatchingCSV}
                >
                  Cancel
                </AdxButton>
                <AdxButton variant={'contained'} sx={{ width: '200px' }} onClick={handleUpload}>
                  Add
                </AdxButton>
              </Box>
            )}
          </Box>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default UploadMatching
